/**
 * 主项目：只把「新/旧」标识写入 sessionStorage
 * 实际前缀由 train/airticket 发请求时 getTrainApiPrefix 再映射
 * 缺省：旧（FLAG_LEGACY / api）
 */

import {
  TRAIN_SETTINGS_IS_USE_NEW_TRAIN,
  TRAIN_API_PREFIX_FLAG_NEW,
  TRAIN_API_PREFIX_FLAG_LEGACY,
  TRAIN_API_PREFIX_LEGACY,
  TRAIN_API_PREFIX_NEW,
  TRAIN_UNIT_API_PREFIX_KEY,
} from '@/common/constants/trainApiPrefix'

export {
  TRAIN_API_PREFIX_CACHE_KEY,
  TRAIN_SETTINGS_IS_USE_NEW_TRAIN,
  TRAIN_API_PREFIX_LEGACY,
  TRAIN_API_PREFIX_NEW,
  TRAIN_API_PREFIX_DEFAULT,
  TRAIN_API_PREFIX_FLAG_NEW,
  TRAIN_API_PREFIX_FLAG_LEGACY,
  TRAIN_UNIT_API_PREFIX_KEY,
} from '@/common/constants/trainApiPrefix'

/** 归一化为 0 | 1 */
export function normalizeTrainApiPrefixFlag(flag) {
  if (flag === TRAIN_API_PREFIX_FLAG_NEW || flag === true || flag === 1 || flag === '1') {
    return TRAIN_API_PREFIX_FLAG_NEW
  }
  if (flag === TRAIN_API_PREFIX_FLAG_LEGACY || flag === false || flag === 0 || flag === '0') {
    return TRAIN_API_PREFIX_FLAG_LEGACY
  }
  if (flag === TRAIN_API_PREFIX_NEW || String(flag).toLowerCase() === 'new') {
    return TRAIN_API_PREFIX_FLAG_NEW
  }
  if (flag === TRAIN_API_PREFIX_LEGACY || String(flag).toLowerCase() === 'legacy' || String(flag).toLowerCase() === 'old') {
    return TRAIN_API_PREFIX_FLAG_LEGACY
  }
  return TRAIN_API_PREFIX_FLAG_LEGACY
}

/** 标识 → 前缀（主项目一般不用；与子应用保持同名） */
export function resolveTrainApiPrefixFromFlag(flag) {
  return normalizeTrainApiPrefixFlag(flag) === TRAIN_API_PREFIX_FLAG_LEGACY
    ? TRAIN_API_PREFIX_LEGACY
    : TRAIN_API_PREFIX_NEW
}

/** 从 Settings 取标识（读 TrainSettings.IsUseNewTrain boolean） */
export function extractTrainApiPrefixFromSettings(settings) {
  if (!settings || typeof settings !== 'object') {
    return TRAIN_API_PREFIX_FLAG_LEGACY
  }
  const flag =
    settings.TrainSettings && settings.TrainSettings[TRAIN_SETTINGS_IS_USE_NEW_TRAIN] != null
      ? settings.TrainSettings[TRAIN_SETTINGS_IS_USE_NEW_TRAIN]
      : settings[TRAIN_SETTINGS_IS_USE_NEW_TRAIN]
  if (flag === undefined || flag === null || flag === '') {
    return TRAIN_API_PREFIX_FLAG_LEGACY
  }
  return normalizeTrainApiPrefixFlag(flag)
}

/** 写入 session：只存标识 0/1 */
export function setUnitTrainApiPrefix(flag) {
  const f = normalizeTrainApiPrefixFlag(
    flag === undefined || flag === null || flag === '' ? TRAIN_API_PREFIX_FLAG_LEGACY : flag
  )
  try {
    window.sessionStorage.setItem(TRAIN_UNIT_API_PREFIX_KEY, String(f))
  } catch (e) {
    // ignore
  }
  return f
}

export function syncTrainUnitApiPrefixFromSettings(settings) {
  return setUnitTrainApiPrefix(extractTrainApiPrefixFromSettings(settings))
}

export function clearTrainUnitApiPrefix() {
  try {
    window.sessionStorage.removeItem(TRAIN_UNIT_API_PREFIX_KEY)
  } catch (e) {
    // ignore
  }
}
